import Litepicker from 'litepicker';




function initFilterableEvents(filterableEventsContainers) {
    if (!filterableEventsContainers || !filterableEventsContainers.length) return;

    for (let eventsContainer of filterableEventsContainers) {
        // check if all the required Nodes are inside the container
        const eventItemElements= eventsContainer.querySelectorAll('.events-list-wrapper .event-item');
        const eventItems= Array.from(eventItemElements);
        if (!eventItems) continue;

        const locationFilter= eventsContainer.querySelector('.location-filter>select');
        const datepickerContainer= eventsContainer.querySelector('.date-filter>input');
        const resetFilterLink=eventsContainer.querySelector('.reset-filter-link');
        if (!locationFilter || !datepickerContainer) continue;


        const initialLocationFilterOptions=locationFilter.querySelectorAll('option');

        const initialDateStringsList = createDateStringsList(eventItems);

        if (!initialDateStringsList || !initialDateStringsList.length) continue;

        let activeLocationFilter= "";

        let activeStartDateFilter = "";
        let activeEndDateFilter = "";


        const toggleResetFilterLink=()=>{
            if(activeLocationFilter!=="" || activeStartDateFilter!=="" || activeEndDateFilter!==""){
                resetFilterLink.classList.remove('hidden');
            }else resetFilterLink.classList.add('hidden');
        }
        toggleResetFilterLink();

        const pageLanguage=document.documentElement.lang || 'de-DE';

        const picker = new Litepicker({
            element: datepickerContainer,
            scrollToDate: true,
            singleMode: false,
            lang: pageLanguage,
            format: 'DD.MM.YYYY',
            tooltipText: pageLanguage==='de-DE'? {one: 'Tag', other: 'Tage'} : {one: 'day', other: 'days'},
            lockDaysFilter: (date1) => {
                return !initialDateStringsList.includes(date1.toDateString());
            }
        });
        picker.on('selected', (start, end)=>{
            if(!start || !end) return;
            // when both start and end date were selected
            activeStartDateFilter = start.getTime();
            activeEndDateFilter = end.getTime() + 86400000; // unix in milliseconds + 24h in milliseconds to get the end of the day
            applyDateFilter();
        })

        const applyDateFilter=()=>{
            toggleResetFilterLink();

            // filter all events by start and end date
            const dateFilteredEvents=eventItems.filter(eventElement=>{
                const unixTimestamp= parseInt(eventElement.dataset?.date) * 1000;
                if(unixTimestamp>activeStartDateFilter && unixTimestamp<=activeEndDateFilter){
                    eventElement.classList.remove('hidden');
                    return true;
                }else{
                    eventElement.classList.add('hidden');
                    return false;
                }
            })

            // update location filter select options to only include options inside the filtered date range
            updateLocationFilterOptions(locationFilter, initialLocationFilterOptions, dateFilteredEvents);

            // further filter the date filtered events by city now
            if(activeLocationFilter!==""){ // if active location filter is not empty
                dateFilteredEvents.forEach(eventElement=>{
                    const cityUid=eventElement.dataset?.cityUid;
                    if(cityUid != activeLocationFilter){  // hide all the events that do not match the cityUid
                        eventElement.classList.add('hidden');
                    }
                })
            }

            persistFilters();
        }


        // location filter
        locationFilter.addEventListener('change', (e) => {
            activeLocationFilter = e.target.value;
            applyLocationFilter();
        })

        const applyLocationFilter=()=>{
            toggleResetFilterLink();

            const locationFilteredEvents=eventItems.filter(eventElement=>{
                const cityUid=eventElement.dataset?.cityUid;
                if(activeLocationFilter==="" ||  cityUid == activeLocationFilter){
                    eventElement.classList.remove('hidden');
                    return true;
                }else{
                    eventElement.classList.add('hidden');
                    return false;
                }
            })

            const updatedDateStrings = createDateStringsList(locationFilteredEvents);
            picker.setOptions({lockDaysFilter: (date1) => {
                    return !updatedDateStrings.includes(date1.toDateString());
                }})

            if(activeStartDateFilter>0 || activeEndDateFilter>0){
                locationFilteredEvents.forEach(eventElement=>{
                    const unixTimestamp= parseInt(eventElement.dataset?.date) * 1000;
                    // if activeStartDateFilter is a valid timestamp and the event is BEFORE this stamp
                    if(activeStartDateFilter>0 && unixTimestamp<activeStartDateFilter){
                        eventElement.classList.add('hidden');
                        return;
                    }

                    // if activeEndDateFilter is a valid timestamp and the event is AFTER this stamp
                    if(activeEndDateFilter>0 && unixTimestamp>activeEndDateFilter){
                        eventElement.classList.add('hidden');
                    }

                })
            }

            persistFilters();
        }

        const persistFilters=()=>{
            const filters={
                location: activeLocationFilter,
                from: activeStartDateFilter,
                to: activeEndDateFilter
            }

            const encodedFilterString=Object.entries(filters)
                .reduce((result,[filterKey, filterValue])=> {
                    if(filterValue && filterValue !== '')  result.push(`${filterKey}=${filterValue}`)
                    return result;
                }, [])
                .join('&');

            if(encodedFilterString && encodedFilterString!==''){
                window.location.hash=encodedFilterString;

            }else {
                history.replaceState({}, document.title, window.location.href.split('#')[0]);
            }
        }

        const loadFiltersFromUrlHash=()=>{
            const encodedFilterString=window.location.hash.substring(1);
            if(!encodedFilterString || encodedFilterString==='') return;

            const storedFilters=encodedFilterString.split('&').reduce((filters, filterString)=>{
                const [key, val]=filterString.split('=');
                filters[key]=val;
                return filters;
            }, {})

            if(storedFilters.location){
                activeLocationFilter=storedFilters.location;
                locationFilter.value=activeLocationFilter;
            }


            if(storedFilters.from && storedFilters.to){
                activeStartDateFilter=parseInt(storedFilters.from);
                activeEndDateFilter= parseInt(storedFilters.to);

                picker.setDateRange(new Date(activeStartDateFilter), new Date(activeEndDateFilter - 86400000));
            }else{
                if(locationFilter && locationFilter!==''){
                    applyLocationFilter();
                }
            }
        }

        resetFilterLink.addEventListener('click',(e)=>{
            e.preventDefault();
            activeLocationFilter="";
            locationFilter.value=activeLocationFilter;
            activeStartDateFilter="";
            activeEndDateFilter="";
            picker.clearSelection();

            eventItems.forEach(item=>item.classList.remove("hidden")); // re enable all events
            picker.setOptions({lockDaysFilter: (date1) => {
                    return !initialDateStringsList.includes(date1.toDateString());
                }})
            locationFilter.innerHTML="";
            initialLocationFilterOptions.forEach(option=>locationFilter.appendChild(option));
            resetFilterLink.classList.add('hidden'); // hide the reset filter element since no filters are selected anymore

            persistFilters();
        })

        loadFiltersFromUrlHash();


    }
}




function updateLocationFilterOptions(filterElement, locationOptionsList, eventItems){
    const optionsMap = {};
    // iterate over all event items to find all city uids and count them
    for (let item of eventItems) {
        const cityUid = item.dataset.cityUid;
        if(!cityUid) continue;
        // create a map of location keys and their count
        optionsMap[cityUid] = optionsMap[cityUid] ? optionsMap[cityUid] + 1 : 1;
    }

    const emptyOption=locationOptionsList[0];
    filterElement.innerHTML='';
    filterElement.appendChild(emptyOption)

    for(let option of locationOptionsList){
        if(optionsMap[option.value]){
            filterElement.appendChild(option);
        }
    }

}

function createDateStringsList(eventItems) {
    const dates = [];
    // iterate over all event items to find all available dates
    for (let item of eventItems) {
        if (item.classList.contains("hidden")) continue;
        dates.push(new Date(parseInt(item.dataset.date) * 1000).toDateString());
    }
    return dates;
}




initFilterableEvents(document.querySelectorAll('.filterable-events-wrapper'))



document.querySelectorAll('.has-tooltip').forEach(element=>{
    element.addEventListener('click', function(e){
        this.classList.toggle('active');
    })
})


document.querySelectorAll('.location-map-anchor').forEach(element=>{
    element.addEventListener('click', ()=>{
        const mapElement=document.querySelector('.map-wrapper');
        mapElement.scrollIntoView({block: 'end', behavior: 'smooth'})
    })
})